var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import OperationReportService from '../../api/OperationReportService';
import RequiredMixin from '../../components/renderHeader/RequiredMixin';
import { EBillType } from "../../enum/EBillType";
import GlobalVue from '../../globalVue';
import LossAnastleDetails from "./LossAnasyleDetails.vue";
import Header from "./components/LossHeader.vue";
var OperationReport = (function (_super) {
    __extends(OperationReport, _super);
    function OperationReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.summaryListData = [];
        _this.listData = [];
        _this.tableHeight = document.documentElement.clientHeight - 220;
        _this.eBillType = EBillType;
        _this.total = 0;
        return _this;
    }
    OperationReport.prototype.created = function () {
        this.service = OperationReportService.getInstance();
    };
    OperationReport.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {
            s_time: this.filter.s_time,
            e_time: this.filter.e_time,
            goods_type_id: (this.filter.goods_type_id || []).join(','),
            depot_ids: (this.filter.depot_ids || []).join(','),
            keyword: this.filter.keyword
        };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getAnasyleList(params).then(function (res) {
            _this.summaryListData = res.data.data;
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    OperationReport.prototype.search = function (filter) {
        this.filter = filter;
        this.$refs.pagination.clear();
        this.getList();
    };
    OperationReport.prototype.pageChange = function (pager) {
        this.getList();
    };
    OperationReport.prototype.lookDetail = function (row) {
        var newRow = row;
        newRow.s_time = this.filter.s_time;
        newRow.e_time = this.filter.e_time;
        GlobalVue.$emit('addTab', {
            component: LossAnastleDetails,
            title: '损耗分析图',
            showExist: false,
            name: 'loss-Anastled-Details',
            cprops: {
                rowId: newRow
            },
        });
    };
    OperationReport = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'list-header': Header
            },
            methods: {},
        })
    ], OperationReport);
    return OperationReport;
}(Vue));
export default OperationReport;
